<style>
  .delete {
    cursor: pointer;
  }
</style>

<svg class="delete" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 25">
  <path d="M6.25 9.17a.83.83 0 00-.83.83v10.83a.83.83 0 101.66 0V10a.83.83 0 00-.83-.83zM10 9.17a.83.83 0 00-.83.83v10.83a.83.83 0 101.66 0V10a.83.83 0 00-.83-.83zM13.75 9.17a.83.83 0 00-.83.83v10.83a.83.83 0 101.66 0V10a.83.83 0 00-.83-.83z" fill="#000"/>
  <path d="M18.75 2.5h-3.78L13.14.3a.83.83 0 00-.64-.3h-5a.83.83 0 00-.64.3L5.03 2.5H1.25A1.25 1.25 0 000 3.75v2.5A1.25 1.25 0 001.25 7.5h.42v15.83A1.67 1.67 0 003.33 25h13.34a1.67 1.67 0 001.66-1.67V7.5h.42A1.25 1.25 0 0020 6.25v-2.5a1.25 1.25 0 00-1.25-1.25zM7.89 1.67h4.22l.7.83H7.2l.7-.83zM3.33 23.33V7.5h13.34v15.83H3.33zm15-17.5H1.67V4.17h16.66v1.66z" fill="#000"/>
</svg>